import axios from "axios";

export type ServerErrorData = Record<string, unknown>;

export const getServerErrorData = (error: unknown): ServerErrorData | null => {
  if (!axios.isAxiosError(error)) {
    return null;
  }
  const data = error.response?.data;
  if (!data || typeof data !== "object") {
    return null;
  }
  return data as ServerErrorData;
};

export const getStatusCode = (error: unknown): number | null =>
  axios.isAxiosError(error) ? error.response?.status ?? null : null;

const valueMessages = (value: unknown): string[] => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed ? [trimmed] : [];
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return [String(value)];
  }
  if (Array.isArray(value)) {
    return value.flatMap(valueMessages);
  }
  if (value && typeof value === "object") {
    return Object.values(value as Record<string, unknown>).flatMap(valueMessages);
  }
  return [];
};

export const getServerErrorMessage = (
  error: unknown,
  fallback = "Не удалось выполнить операцию",
): string => {
  const data = getServerErrorData(error);
  if (data) {
    for (const key of ["detail", "error", "message", "non_field_errors"]) {
      const messages = valueMessages(data[key]);
      if (messages.length) return messages.join(". ");
    }
    const messages = Object.values(data).flatMap(valueMessages);
    if (messages.length) return messages.join(". ");
  }

  if (axios.isAxiosError(error)) {
    if (!error.response) return "Не удалось связаться с сервером. Проверьте подключение и повторите попытку.";
    if (error.message) return error.message;
  }

  return fallback;
};

export const getServerFieldErrors = (
  error: unknown,
  allowedFields: readonly string[],
): Record<string, string> => {
  const data = getServerErrorData(error);
  if (!data) return {};

  return allowedFields.reduce<Record<string, string>>((result, field) => {
    const messages = valueMessages(data[field]);
    if (messages.length) result[field] = messages.join(". ");
    return result;
  }, {});
};